/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';
import { IDialogConfirm } from './ami-dialog-confirm.interface';

@Component({
  selector: 'ami-dialog-confirm',
  templateUrl: './ami-dialog-confirm.component.html',
  styleUrls: ['../../../../assets/demo/badges.scss']
})
export class AmiDialogConfirmComponent {
  @Input() setting: IDialogConfirm;
  @Output() confirmed = new EventEmitter<IDialogConfirm>();

  visible = false;
  isProcessing = false;
  textColor: string;
  message: string;

  ngOnChanges(changes: SimpleChanges): void {
    const currentValue = changes.setting?.currentValue;
    const message = currentValue?.message;
    if (message) {
      this.message = currentValue?.message;
    }
    this.visible = this.message ? true : false;
  }
  confirm() {
    this.confirmed.emit(this.setting);
    this.visible = false;
  }
}
